import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

/** Shared chrome for public and authenticated routes. */
const SiteLayout: React.FC = () => {
  return (
    <div className="layout">
      <Navbar />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default SiteLayout;
